jQuery(function($) {
    jQuery(document).ready(function() {

        //HEADER SLICKNAV MENU JS
        jQuery('.main-menu').slicknav({
            prependTo:'.header-section .menu-area',
            closeOnClick: true,
            label: 'Menu',
            duration: 1000,
        });

        // HERO SLIDER JS
        jQuery('.hero-slider').owlCarousel({
            margin:0,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:false,
                    dots: true
                },
                980:{
                    items:1,
                    nav:true,
                    loop:false
                }
            }
        })

        // EXPLORING SLIDER JS
        jQuery('.exploring-slider ').owlCarousel({
            loop:true,
            margin:10,
            responsiveClass:true,
            responsive:{
                0:{
                    items:2,
                    nav:true
                },
                600:{
                    items:2,
                    nav:false
                },
                830:{
                    items:3,
                    nav:false
                },
                980:{
                    items:4,
                    nav:true,
                    loop:false
                }
            }
        });

        // modal mobile Watches SLIDER JS
        jQuery('.mobile-watch-img-slider ').owlCarousel({
            loop:true,
            margin:10,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                600:{
                    items:1,
                    nav:false
                },
                830:{
                    items:2,
                    nav:false
                },
                980:{
                    items:4,
                    nav:true,
                    loop:false
                }
            }
        })

        // VIDEO JS
        $(".video-area").fitVids();

      /* TABS AREA START */
        jQuery('#tab1').click(function(){

            jQuery('.tab-btn').removeClass('active-btn');
            jQuery(this).addClass('active-btn');

            jQuery('.tab-content').removeClass('active-content');
            jQuery("#tab-content1").addClass('active-content');

        });

        jQuery('#tab2').click(function(){

            jQuery('.tab-btn').removeClass('active-btn');
            jQuery(this).addClass('active-btn');

            jQuery('.tab-content').removeClass('active-content');
            jQuery("#tab-content2").addClass('active-content');

        });

        $('.js-load-more').on('click', function(e){
          e.preventDefault();
          var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
          currentPage = currentPage+1;
          if(totalPages == currentPage){
            $this.hide();
          }
          var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
          $('[data-current-page]').val(currentPage);
          $.ajax({
            url: nextUrl,
            type: 'GET',
            dataType: 'html',
            success: function(responseHTML){
              $('.perpetual-model-items').append($(responseHTML).find('.perpetual-model-items').html());
            }
          })
        });

        $(".pceDisplay img").hover(function() {
            $(".tooltip-content").show();
        }, function() {
            $(".tooltip-content").hide();
        });

    });

});
